import {Component, forwardRef, inject, ViewChild} from '@angular/core';
import {ExtendedModule} from '@angular/flex-layout';
import {MatIcon} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NavigationEnd, Router} from '@angular/router';
import {AuthenticationService} from '@modules/authentication';
import {brand, brandLogoSvg, useBrandTwoDifferentSvg} from 'app/settings';
import {FuseNavigationModule} from 'fuse-core/components';
import {FuseSidebarService} from 'fuse-core/components/sidebar/sidebar.service';
import {FuseDirectivesModule} from 'fuse-core/directives/directives';
import {FusePerfectScrollbarDirective} from 'fuse-core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import {filter, take} from 'rxjs/operators';
import {PrettyEasyAccordionLinkGroupComponent} from './pretty-easy-accordion-link-group/pretty-easy-accordion-link-group.component';
import {PrettyEasyLinkGroupComponent} from './pretty-easy-link-group/pretty-easy-link-group.component';
import {PrettyEasyLinkComponent} from './pretty-easy-link/pretty-easy-link.component';
import {PrettyEasyNavigationService} from './pretty-easy-navigation.service';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-pretty-easy-navigation',
  standalone: true,
    imports: [
        PrettyEasyLinkComponent,
        forwardRef(() => PrettyEasyLinkGroupComponent),
        forwardRef(() => PrettyEasyAccordionLinkGroupComponent),
        MatSidenavModule,
        ExtendedModule,
        FuseDirectivesModule,
        FuseNavigationModule,
        MatIcon,
        MatTooltipModule,
        TranslateModule,
    ],
  templateUrl: './pretty-easy-navigation.component.html'
})
export class PrettyEasyNavigationComponent /* implements OnDestroy, OnInit */ {

    private fuseSidebarService= inject(FuseSidebarService)
    private router= inject(Router)
    private authenticationService= inject(AuthenticationService)
    private prettyEasyNavigationService = inject(PrettyEasyNavigationService);

    public menu = this.prettyEasyNavigationService.menu;
    public brand = brand;
    public brandLogoSvg = brandLogoSvg;
    public useBrandTwoDifferentSvg = useBrandTwoDifferentSvg;

    private fusePerfectScrollbar: FusePerfectScrollbarDirective;


    @ViewChild(FusePerfectScrollbarDirective, {static: true})
    set directive(theDirective: FusePerfectScrollbarDirective) {
        if (!theDirective) {
            return;
        }

        this.fusePerfectScrollbar = theDirective;


        // Scroll to the active item position
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                    setTimeout(() => {
                        const activeNavItem: any = document.querySelector('navbar .nav-link.active');

                        if (activeNavItem) {
                            const activeItemOffsetTop = activeNavItem.offsetTop,
                                activeItemOffsetParentTop = activeNavItem.offsetParent?.offsetTop,
                                scrollDistance = activeItemOffsetTop - activeItemOffsetParentTop - (48 * 3);

                            this.fusePerfectScrollbar.scrollToTop(scrollDistance);
                        }
                    });
                }
            );
    }

    closeSidebar(): void {
        this.fuseSidebarService.getSidebar('navbar').close();
    }

    toggleSidebarFolded(): void {
        this.fuseSidebarService.getSidebar('navbar').toggleFold();
    }

    public unfoldSidebar(): void {
        this.fuseSidebarService.getSidebar('navbar').unfold();
    }

    public isSidebarFolded(): boolean {
        if (this.fuseSidebarService.getSidebar('navbar').folded) {
            return true
        }
        return false;
    }

    public navigate(): void {
        this.authenticationService.overrideDefaultRouteInRegardOfRole(true);
    }
}
